import { EmailProvider, PhoneOtpProvider } from 'apis/notification-providers';

export const phoneOtpProviderLabels: Record<PhoneOtpProvider, string> = {
  twilio_sms: 'Twilio SMS',
  cequens_sms: 'Cequens SMS',
  twilio_whatsapp: 'Twilio WhatsApp',
};

export const emailProviderLabels: Record<EmailProvider, string> = {
  resend: 'Resend',
  sendgrid: 'SendGrid',
};

/** One row of the editable phone-code order. */
export interface PhoneOrderRow {
  id: PhoneOtpProvider;
  included: boolean;
}

/** The used providers in their order, then every other known provider, left out. */
export const toPhoneOrderRows = (providers: PhoneOtpProvider[], known: PhoneOtpProvider[]): PhoneOrderRow[] => [
  ...providers.map((id) => ({ id, included: true })),
  ...known.filter((id) => !providers.includes(id)).map((id) => ({ id, included: false })),
];

/** The order to save: the included rows, top first. */
export const toProviders = (rows: PhoneOrderRow[]): PhoneOtpProvider[] =>
  rows.filter((row) => row.included).map((row) => row.id);

/** `rows` with the row at `index` moved one place up (-1) or down (+1); unchanged at either end. */
export const moveRow = (rows: PhoneOrderRow[], index: number, step: -1 | 1): PhoneOrderRow[] => {
  const target = index + step;
  if (target < 0 || target >= rows.length) {
    return rows;
  }
  const moved = [...rows];
  [moved[index], moved[target]] = [moved[target], moved[index]];
  return moved;
};

export const sameOrder = (a: PhoneOtpProvider[], b: PhoneOtpProvider[]): boolean =>
  a.length === b.length && a.every((id, index) => id === b[index]);
